import { formatDateToView } from '../../lib/DateTime';

const DashboardDefects = (
    {
        selectedDefect,
        selectedDriver,
        openDefects,
        theme,
    }
) => {
    return (
        <>
        <div style={{ textAlign: 'center' }}>
            <h3>Driver Defects</h3>
        </div>
        {selectedDefect && selectedDefect.length > 0 ? (
            selectedDefect.map((defect) => (
                <div
                    className="defect-container"
                    key={defect.id}
                    style={{
                        flexDirection: 'column',
                        margin: '20px auto',
                        maxWidth: 800,
                        width: '100%',
                    }}
                >
                    <h5>
                        <strong>Defect Details</strong>
                        {defect.trailer_dropped && (
                            <span style={{ margin: '10px 0px 0px 10px', color: 'red' }}>Trailer Dropped</span>
                        )}
                    </h5>

                    {/* Always show date, vehicle_reg, and duration */}
                    {['date', 'submitted_at', 'vehicle_reg', 'mileage', 'duration'].map((key) => {
                        const value = defect[key];
                        if (!value) return null; // Skip if value is missing
                        const formattedKey = key.replace(/_/g, ' ').charAt(0).toUpperCase() + key.replace(/_/g, ' ').slice(1);
                        return (
                            <p
                                key={key}
                                style={{
                                    marginBottom: '0px',
                                    marginLeft: '5px',
                                    padding: '5px',
                                }}
                            >
                                <strong>{key === 'vehicle_reg' && defect.vehicle_type === 'TRAILER' ? 'Trailer ID' : key === 'vehicle_reg' && defect.vehicle_type === 'MHE' ? 'Equipment ID' : formattedKey}:</strong> {key === 'date' ? formatDateToView(value) : value}
                            </p>
                        );
                    })}

                    {/* Other defect details in 3 columns */}
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, 1fr)',
                            gap: '10px',
                            marginTop: '15px',
                        }}
                    >
                        {Object.keys(defect).map((key) => {
                            const value = defect[key];
                            if (!value && value !== false) return null; // Skip if not a valid value
                            if (['date', 'vehicle_reg', 'duration', 'comments', 'images', 'repair_ids', 'id', 'trailer_dropped'].includes(key)) return null; // Skip prioritized keys
                            if (typeof value !== 'boolean') return null; // Skip non-boolean values

                            const displayValue = value ? 'Passed' : 'Failed';
                            const backgroundColor = value
                                ? theme === 'light'
                                    ? 'rgba(174, 247, 138, 0.7)'
                                    : 'rgba(174, 247, 138, 0.3)'
                                : defect.check_status === 'repaired'
                                    ? 'rgba(25, 151, 235, 0.8)'
                                : theme === 'light'
                                    ? 'rgba(247, 138, 138, 0.7)'
                                    : 'rgba(247, 138, 138, 0.3)';
                            const formattedKey = key.replace(/_/g, ' ').charAt(0).toUpperCase() + key.replace(/_/g, ' ').slice(1);

                            return (
                                <div
                                    key={key}
                                    style={{
                                        backgroundColor,
                                        padding: '5px',
                                        borderRadius: '5px',
                                    }}
                                >
                                    <strong>{formattedKey}:</strong> {!value && defect.check_status === 'repaired' ? 'Repaired' : displayValue}
                                </div>
                            );
                        })}
                    </div>

                    {/* Display images in a horizontal scrollable view (max 4) */}
                    {defect.images && defect.images.length > 0 && (
                        <div
                            style={{
                                display: 'flex',
                                overflowX: 'auto',
                                marginTop: '15px',
                                gap: '10px',
                            }}
                        >
                            {defect.images.slice(0, 4).map((img, index) => (
                                <img
                                    key={index}
                                    src={img}
                                    alt={`Defect ${index + 1}`}
                                    style={{
                                        width: '20%',
                                        borderRadius: '5px',
                                        objectFit: 'cover',
                                    }}
                                />
                            ))}
                        </div>
                    )}

                    {/* Display comment at the bottom */}
                    {defect.comments && (
                        <div
                            style={{
                            marginTop: '15px',
                            padding: '5px',
                            borderTop: theme === 'light' ? '1px solid #000' : '1px solid #fff',
                            }}
                        >
                            <p
                            style={{
                                marginBottom: '10px',
                                marginLeft: '0px',
                                padding: '5px',
                                borderRadius: '5px',
                            }}
                            >
                            <strong>Driver Comments:</strong>
                            </p>
                            {/* Split the comments by commas and map through each comment */}
                            {defect.comments.map((comment, index) => {
                            const [header, body] = comment.split(': '); // Split each comment by ": "
                            const formattedTitle = header.replace(/_/g, ' ').charAt(0).toUpperCase() + header.replace(/_/g, ' ').slice(1);
                            return (
                                <div key={index} style={{ marginBottom: '10px' }}>
                                <strong>{formattedTitle}:</strong> {body}
                                </div>
                            );
                            })}
                        </div>
                        )}


                    {/* Display button at the bottom */}
                    {defect.check_status === 'failed' && (
                        <div className="show-defects-button">
                            <button
                                className="btn btn-primary"
                                style={{
                                    marginTop: '10px',
                                    padding: '5px',
                                    borderRadius: '5px',
                                }}
                                title="View Defects"
                                onClick={() => { openDefects(defect.defect_ids); }}
                            >
                                Open Defects
                            </button>
                        </div>
                    )}
                </div>
            ))
        ) : (
            <div style={{ textAlign: 'center' }}>
                {selectedDriver ? (
                    <p>No defects submitted!</p>
                ) : (
                    <p>Please select a driver from the list</p>
                )}
            </div>
        )}
        </>
    )}

    export default DashboardDefects;